const MainUrl = 'https://api.gosparklex.com/';

export default MainUrl;